import { Link, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { API_URL, COLORS } from 'config/constants'

import {
  downloadApplicationDocument,
  normalizeApplicationDownloadUrl,
} from '../download-application-document'

const ApplicationDocumentLink = ({ document }: ApplicationDocumentLinkProps) => {
  const { t } = useTranslation()

  const filename = document.title || document.filetype || t('applications__text__blockDocumentFallback')

  const downloadPath = normalizeApplicationDownloadUrl(document.file)
  const href = `${API_URL.replace(/\/$/, '')}/${downloadPath}`

  return (
    <Link
      href={href}
      variant='body2'
      underline='always'
      onClick={(event) => {
        event.preventDefault()
        downloadApplicationDocument({ downloadUrl: document.file, filename }).catch(() => undefined)
      }}
      sx={{
        color: COLORS.BLUE,
        cursor: 'pointer',
        textAlign: 'left',
        overflowWrap: 'anywhere',
        '&:hover': {
          color: COLORS.BLUE_DARK,
        },
      }}
    >
      <Typography component='span' variant='inherit' sx={{ color: 'inherit' }}>
        {filename}
      </Typography>
    </Link>
  )
}

export default ApplicationDocumentLink
